// @flow
import color from 'tinycolor2';
import hashString from 'hash-string';

const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
const MAX = 360;
const MIN = 0;
const OFFSET = 3;
const OUT_OF_BOUNDS = 1000000000;

function hue(hue) {
  return color({h: hue, s: 100, l: 50})
    .desaturate(35)
    .lighten(15)
    .toHexString();
}

export function alpha(hex: string, alpha: number = 0.5): string {
  return color(hex).setAlpha(alpha).toRgbString();
}

export function complement(hex: string): string {
  return color(hex).complement().toHexString();
}

export function forString(str: string = ''): string {
  return forIndex(hashString(str.toLowerCase()));
}

export function forIndex(index: number): string {
  if (index === OUT_OF_BOUNDS) {
    return '#AAAAAA';
  }
  const seed = (GOLDEN_RATIO * (index + OFFSET)) % 1;
  return hue(MIN + seed * (MAX - MIN));
}



/** WEBPACK FOOTER **
 ** ./src/lib/Color.js
 **/